import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, useNavigate, useParams } from "react-router-dom";
import HeaderAfterLogin from "../../../../containers/HeaderAfterLogin";
import Header from "../../../../containers/Header";
import { casinoTypes } from "../../../../lib/data/casinoTypes.data";
import MainSlider from "../../../../containers/MainSlider";

import EvolutionImg from "../../../../assets/images/icons/casino/provider-evo.webp";
import EzugiImg from "../../../../assets/images/icons/casino/provider-ezugi.webp";
import SpribeImg from "../../../../assets/images/icons/casino/provider-Spribe.png";
import SupernowaImg from "../../../../assets/images/icons/casino/Supernowa.webp";
import AuraImg from "../../../../assets/images/icons/casino/AuraGame.webp";
import KingmakerImg from "../../../../assets/images/icons/casino/Kingmaker.webp";
import RouletteIcon from "../../../../assets/images/icons/casino/ROulette.webp";
import BaccaratIcon from "../../../../assets/images/icons/casino/Baccarat.webp";
import TeenPattiIcon from "../../../../assets/images/icons/casino/Teenpatti.webp";
import BlackjackIcon from "../../../../assets/images/icons/casino/Blackjack.webp";
import Lucky7 from "../../../../assets/images/icons/casino/Lucky7.webp";
import Crapsicon from "../../../../assets/images/icons/casino/Craps.webp";
import SicboIcon from "../../../../assets/images/icons/casino/sic-bo.webp";
import GameShowsIcon from "../../../../assets/images/icons/casino/Gameshow.webp";
import AndarbaharIcon from "../../../../assets/images/icons/casino/AndarBahar.webp";
import card32 from "../../../../assets/images/icons/casino/cards32.webp";
import rngGames from "../../../../assets/images/icons/casino/RNG.webp";
import cardsGames from "../../../../assets/images/icons/casino/CardGames.webp";
import virtualCardGames from "../../../../assets/images/icons/casino/virtualCardGames.webp";
import InstantGamesIcon from "../../../../assets/images/icons/casino/InstantGames.webp";
import minesIcon from "../../../../assets/images/icons/casino/Mines.webp";
import NetEntIcon from "../../../../assets/images/icons/casino/Netent.webp";
import RedTigerIcon from "../../../../assets/images/icons/casino/RedTiger.webp";
import Jiliicon from "../../../../assets/images/icons/casino/Jili.webp";
import turbogamesIcon from "../../../../assets/images/icons/casino/Mines.webp";
import CrashIcon from "../../../../assets/images/icons/casino/Mines.webp";
import CrashXIcon from "../../../../assets/images/icons/casino/Mines.webp";
import hiLoIcon from "../../../../assets/images/icons/casino/Hilo.png";
import mac88vr from "../../../../assets/images/icons/casino/Mac88vr.png";
import mac88 from "../../../../assets/images/icons/casino/MAC88.webp";
import playngoIcon from "../../../../assets/images/icons/casino/PascalGames.webp";
import relaxGamingIcon from "../../../../assets/images/icons/casino/relaxgaming.webp";
import HabaneroIcon from "../../../../assets/images/icons/casino/habenero.webp";
import dragoonSoftIcon from "../../../../assets/images/icons/casino/dragoonsoft.webp";
import dragontigerIcon from "../../../../assets/images/icons/casino/DragonTiger.png";
import WingoIcon from "../../../../assets/images/icons/casino/ROulette.webp";
import LotteryIcon from "../../../../assets/images/icons/casino/lottery.webp";
import OtherIcon from "../../../../assets/images/icons/casino/Other.webp";
import live88Icon from "../../../../assets/images/icons/casino/live88.png";
import onetouchIcon from "../../../../assets/images/icons/casino/onetouch.png";
import pascalgamingicon from "../../../../assets/images/icons/casino/PascalGames.webp";
import truelabsicon from "../../../../assets/images/icons/casino/truelabs.png";
import smartSoft from "../../../../assets/images/icons/casino/smartsoft.webp";
import tablegamesIcon from "../../../../assets/images/icons/casino/tablegames.webp";
import BGamingIcon from "../../../../assets/images/icons/casino/BGaming.png";
import galaxysIcon from "../../../../assets/images/icons/casino/hacksaw.png";
import microgamingIcon from "../../../../assets/images/icons/casino/microgaming.png";
import slotsgames from "../../../../assets/images/icons/casino/slots.png";
import hacksawIcon from "../../../../assets/images/icons/casino/hacksaw.png";
import habeneroIcon from "../../../../assets/images/icons/casino/habenero.webp";
import improvedExperience from "../../../../assets/images/icons/casino/ImprovedExperience.webp";
import Slider from "react-slick";
import { setActiveAuthModalAction } from "../../../../redux/app/actions";
import { AuthModals } from "../../../../config/const";

import ArrowAll from "../../../../assets/images/icons/casino/arrow-right.png";
import ProviderModal from "./ProviderModal";

const Types = [
  {
    id: 0,
    name: "Casino",
    key: "casino",
  },
  {
    id: 1,
    name: "Mini Games",
    key: "miniGames",
  },
  {
    id: 2,
    name: "Lottery",
    key: "lotterygames",
  },
  {
    id: 3,
    name: "Table Games",
    key: "tablegames",
  },
  {
    id: 4,
    name: "Slots",
    key: "slotsgames",
  },
];

export const Providers = [
  { id: 0, name: "Evolution", key: "evolution", img: EvolutionImg },
  { id: 1, name: "Ezugi", key: "ezugi", img: EzugiImg },
  { id: 2, name: "Spribe", key: "spribe", img: SpribeImg },
  { id: 3, name: "Supernowa", key: "supernowa", img: SupernowaImg },
  { id: 4, name: "Aura Gaming", key: "auragames", img: AuraImg },
  // { id: 5, name: "Kingmaker", key: "kingmaker", img: KingmakerImg },
  { id: 6, name: "NetEnt", key: "netent", img: NetEntIcon },
  { id: 7, name: "Red Tiger", key: "redtiger", img: RedTigerIcon },
  { id: 8, name: "Jili", key: "jiligames", img: Jiliicon },
  { id: 9, name: "Turbo Games", key: "turbogames", img: turbogamesIcon },
  // { id: 10, name: "Play'nGo", key: "playngo",img: SpribeImg },
  // { id: 12, name: "Relax Gaming", key: "relaxGaming", img: relaxGamingIcon },
  { id: 12, name: "Habanero", key: "habanero", img: SpribeImg },
  { id: 13, name: "Dragoon Soft", key: "dragoonSoft", img: SpribeImg },
  { id: 14, name: "Mac88", key: "mac88", img: mac88 },
  { id: 14, name: "MAc88 VR", key: "mac88VR", img: mac88vr },
  { id: 15, name: "SmartSoft Games", key: "smartSoft", img: smartSoft },
  { id: 16, name: "Lottery Games", key: "lottery", img: LotteryIcon },
  { id: 17, name: "Table Games", key: "tablegames", img: tablegamesIcon },
  { id: 17, name: "Slots", key: "slotsgames", img: slotsgames },
];

export const Categories = [
  { id: 46, name: "Hot Games", key: "hotGames", img: BGamingIcon },
  { id: 0, name: "Roulette", key: "roulettetab", img: RouletteIcon },
  { id: 1, name: "Baccarat", key: "baccarattab", img: BaccaratIcon },
  { id: 2, name: "Teen Patti", key: "TeenPattitab", img: TeenPattiIcon },
  { id: 3, name: "Blackjack", key: "Blackjacktab", img: BlackjackIcon },
  { id: 4, name: "Lucky 7", key: "lucky7", img: Lucky7 },
  { id: 5, name: "Craps", key: "crapstab", img: Crapsicon },
  { id: 8, name: "Spribe", key: "spribe", img: SpribeImg },
  { id: 9, name: "Sicbo", key: "sicbo", img: SicboIcon },
  // { id: 10, name: "Game Shows", key: "gameshow", img: GameShowsIcon },
  { id: 11, name: "Andar Bahar", key: "andarbahar", img: AndarbaharIcon },
  { id: 12, name: "Cards32", key: "cards32", img: card32 },
  { id: 13, name: "RNG Games", key: "rngames", img: rngGames },
  { id: 14, name: "Card Games", key: "cardGames", img: cardsGames },
  {
    id: 15,
    name: "Virtual Card Games",
    key: "virtualCardGames",
    img: virtualCardGames,
  },
  { id: 16, name: "Instant Games", key: "instantGames", img: InstantGamesIcon },
  { id: 17, name: "Mines", key: "mines", img: minesIcon },
  {
    id: 18,
    name: "Improved Experience",
    key: "improvedExperience",
    img: improvedExperience,
  },
  // { id: 19, name: "Kingmaker", key: "kingmaker", img: KingmakerImg },
  { id: 20, name: "NetEnt", key: "netent", img: NetEntIcon },
  { id: 21, name: "Red Tiger", key: "redtiger", img: RedTigerIcon },
  { id: 22, name: "Jili", key: "jiligames", img: Jiliicon },
  { id: 23, name: "Turbo", key: "turbo", img: turbogamesIcon },
  { id: 24, name: "Crash", key: "crash", img: CrashIcon },
  { id: 27, name: "CrashX", key: "crashx", img: CrashXIcon },
  { id: 28, name: "HiLo", key: "hiLo", img: hiLoIcon },
  { id: 29, name: "Play'nGo", key: "playngo", img: playngoIcon },
  // { id: 30, name: "Relax Gaming", key: "relaxGaming", img: relaxGamingIcon },
  { id: 31, name: "Habanero", key: "habanero", img: HabaneroIcon },
  { id: 32, name: "Dragoon Soft", key: "dragoonSoft", img: dragoonSoftIcon },
  { id: 33, name: "Dragon Tiger", key: "dragontiger", img: dragontigerIcon },
  { id: 34, name: "Wingo", key: "wingo", img: WingoIcon },
  { id: 35, name: "Lottery", key: "lottery", img: LotteryIcon },
  { id: 36, name: "Others", key: "others", img: OtherIcon },
  { id: 37, name: "Pascal Games", key: "pascalgames", img: pascalgamingicon },
  { id: 38, name: "One Touch", key: "onetouch", img: onetouchIcon },
  // { id: 39, name: "Live88", key: "live88", img: live88Icon },
  { id: 40, name: "TRUE LABS", key: "truelabs", img: truelabsicon },
  { id: 41, name: "Hacksaw", key: "hacksaw", img: hacksawIcon },
  { id: 42, name: "Habenero", key: "habenero", img: habeneroIcon },
  { id: 43, name: "Galaxsys", key: "galaxsys", img: galaxysIcon },
  { id: 44, name: "Micro Gaming", key: "microgaming", img: microgamingIcon },
  { id: 45, name: "BGaming", key: "BGaming", img: BGamingIcon },
];

const SliderSettings = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 6,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1199,
      settings: {
        slidesToShow: 6,
        slidesToScroll: 1,
        infinite: true,
        dots: false,
      },
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        dots: false,
      },
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        dots: false,
      },
    },
  ],
};

const AlternativeResponsiveArr = [
  {
    breakpoint: 1199,
    settings: {
      slidesToShow: 6,
      slidesToScroll: 1,
      infinite: true,
      dots: false,
    },
  },
  {
    breakpoint: 991,
    settings: {
      slidesToShow: 2,
      slidesToScroll: 1,
      infinite: true,
      dots: false,
    },
  },
  {
    breakpoint: 767,
    settings: {
      slidesToShow: 2,
      slidesToScroll: 1,
      infinite: true,
      dots: false,
    },
  },
];

const CasinoTypes = () => {
  const { type } = useParams();
  const navigate = useNavigate();
  const { isAuth } = useSelector((state) => state?.auth);
  const selectedTypesData = casinoTypes?.[type] || null;
  const [activeProvider, setActiveProvider] = useState(null);
  const [activeCtg, setActiveCtg] = useState(null);
  const { banners } = useSelector((state) => state.app);
  const [providerModalConfig, setProviderModalConfig] = useState({
    showModal: false,
    defaultActiveProvider: null,
  });

  useEffect(() => {
    if (!selectedTypesData) {
      navigate("/");
      return;
    }

    setInitialValues(selectedTypesData);
  }, [selectedTypesData]);

  const setInitialValues = (data) => {
    const defaultProvider = Providers.find((f) =>
      Object.keys(data).some((s) => s == f?.key),
    );
    setActiveProvider(defaultProvider);

    const defaultCtg = Categories.find((f) =>
      Object.keys(data?.[defaultProvider?.key])?.some((s) => s == f?.key),
    );
    setActiveCtg(defaultCtg);
  };

  const handleProviderChange = (pvd) => {
    setProviderModalConfig({ showModal: true, defaultActiveProvider: pvd });
    // setActiveProvider(pvd);
    // const defaultCtg = Categories.find((f) =>
    //   Object.keys(selectedTypesData?.[pvd?.key])?.some((s) => s == f?.key),
    // );
    // setActiveCtg(defaultCtg);
  };

  return (
    <div>
      {isAuth ? <HeaderAfterLogin /> : <Header />}

      {!selectedTypesData ? (
        <Navigate to="/" />
      ) : (
        <main className="main">
          <div>
            <MainSlider banners={banners} />
          </div>
          <div className="CasinoGamesSection">
            <p className="Heading">
              {Types?.find((f) => f?.key === type)?.name}
            </p>
            <div class="main-category-title__divider"></div>
            <ul className="d-flex ProviderTabs">
              {Providers.filter((f) =>
                Object.keys(selectedTypesData).some((s) => s == f?.key),
              )?.map((pvd, idx) => {
                return (
                  <li
                    key={idx}
                    className={
                      activeProvider && pvd?.key === activeProvider?.key
                        ? "active"
                        : ""
                    }
                    role="button"
                    onClick={() => handleProviderChange(pvd)}>
                    <img src={pvd?.img} alt={pvd?.name} />
                    {pvd?.name}
                  </li>
                );
              })}
            </ul>

            {/* <ul className="d-flex ProviderTabs">
              {selectedTypesData?.[activeProvider?.key] &&
                Categories?.filter((f) =>
                  Object.keys(selectedTypesData?.[activeProvider?.key]).some(
                    (s) => s === f?.key,
                  ),
                )?.map((ctg, idx) => {
                  return (
                    <li
                      key={idx}
                      className={
                        activeCtg && activeCtg?.key === ctg?.key ? "active" : ""
                      }
                      onClick={() => setActiveCtg(ctg)}
                    >
                      <img src={ctg?.img} alt={ctg?.name} />
                      {ctg?.name}
                    </li>
                  );
                })}
            </ul> */}

            <div className="CasinoGameSliderSection">
              {selectedTypesData?.[activeProvider?.key] &&
                Categories?.filter((f) =>
                  Object.keys(selectedTypesData?.[activeProvider?.key]).some(
                    (s) => s === f?.key,
                  ),
                )?.map((ctg, idx) => {
                  const gamesArrayLength =
                    selectedTypesData?.[activeProvider?.key]?.[ctg?.key]
                      ?.length || 0;

                  return (
                    <div key={idx} className="CasinoGameSlider">
                      <div className="d-flex CategoryHeading">
                        <div className="CategoryName">{ctg?.name}</div>
                        <div
                          className="ms-auto allbtn"
                          role="button"
                          onClick={() => {
                            navigate(
                              `/casino-types/${type}/${activeProvider?.key}/${ctg?.key}`,
                            );
                          }}>
                          All <img src={ArrowAll} alt="ArrowAll" />
                        </div>
                      </div>
                      <Slider
                        {...SliderSettings}
                        slidesToShow={
                          gamesArrayLength <= 6
                            ? gamesArrayLength
                            : SliderSettings.slidesToShow
                        }
                        responsive={
                          gamesArrayLength <= 3
                            ? AlternativeResponsiveArr
                            : SliderSettings.responsive
                        }>
                        {" "}
                        {selectedTypesData?.[activeProvider?.key]?.[ctg?.key] &&
                          selectedTypesData?.[activeProvider?.key]?.[
                            ctg?.key
                          ]?.map((game, idx) => {
                            return <GamesCard card={game} key={idx} />;
                          })}
                      </Slider>
                    </div>
                  );
                })}
            </div>

            {/* <ul className="d-flex CasinoGamesImage">
              {selectedTypesData?.[activeProvider?.key]?.[activeCtg?.key] &&
                selectedTypesData?.[activeProvider?.key]?.[activeCtg?.key]?.map(
                  (game, idx) => {
                    return <GamesCard card={game} key={idx} />;
                  },
                )}
            </ul> */}
          </div>
          <ProviderModal
            providerModalConfig={providerModalConfig}
            setProviderModalConfig={setProviderModalConfig}
            data={selectedTypesData}
          />
        </main>
      )}
    </div>
  );
};

export default CasinoTypes;

export const GamesCard = ({ card }) => {
  const navigate = useNavigate();
  const { isAuth } = useSelector((state) => state.auth);
  const dispatch = useDispatch();

  const getImgUrl = () => {
    if (!card) {
      return "";
    }
    if ("imgUrl" in card) {
      return card?.imgUrl;
    }

    if ("cover" in card && "src" in card?.cover) {
      return card?.cover?.src;
    }
    return card?.src;
  };

  const handleRedirection = () => {
    if (!isAuth) {
      dispatch(setActiveAuthModalAction(AuthModals.Login));
      return;
    }
    if (!card) {
      navigate("/");
      return;
    }
    if ("href" in card) {
      navigate(card?.href);
      return;
    }
    if ("redirectUrl" in card) {
      navigate(card?.redirectUrl);
      return;
    }
    return navigate("/");
  };

  return (
    <li onClick={() => handleRedirection()} role="button">
      <img src={getImgUrl()} />
      <p>{card?.name}</p>
    </li>
  );
};
